import { LightbulbAutoOutlineIcon } from './LightbulbAutoOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 34AE1531-6F13-40A5-8E15-ABDD1227DB19
 * name lightbulb-auto-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-auto-outline.svg
 * tags
 * - Home Automation 
 */
export const LightbulbAutomaticOutlineIcon = LightbulbAutoOutlineIcon;
export default LightbulbAutomaticOutlineIcon